<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-12-25 16:53:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/home/components/ProductVer/index.vue
-->
<template>
  <div class="product">
    <div class="top_pos" @click="goDeatil(productDetail.id)">
      <div class="product_img">
        <img :src="productDetail.spuImg" alt="" class="img_img" />
      </div>
      <div v-if="false" class="stock_off">暂时缺货</div>
    </div>
    <div class="mar_con">
      <div class="product_name text_left">{{ productDetail.name }}</div>
      <tags
        :tradeType="productDetail.tradeType"
        :includeTax="productDetail.includeTax"
      />
      <div class="product_price text_left">
        <span>{{ productDetail.storePrice | currency(false) }}</span>
        <img
          v-if="showShare"
          src="@/assets/common/share@2x.png"
          alt=""
          class="share_img right"
          @click="showPoster"
        />
      </div>
    </div>
  </div>
</template>

<script>
const Tags = () => import("@/components/Tags").then(m => m.default || m);
export default {
  components: {
    Tags
  },
  props: {
    productDetail: {
      type: Object,
      default() {
        return {};
      }
    },
    showShare: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    goDeatil(id) {
      // this.$emit("goDeatil");
      this.$router.push({
        path: "/product/detail",
        query: {
          id: id
        }
      });
    },
    showPoster() {
      this.$emit("showPoster", this.productDetail);
    }
  }
};
</script>
<style lang="less" scoped>
.product {
  width: 130px;
  box-shadow: 0px 2px 8px 0px rgba(193, 200, 207, 0.6);
  border-radius: 6px;
  .top_pos {
    position: relative;
    .stock_off {
      width: 88px;
      height: 88px;
      font-size: 18px;
      font-weight: 400;
      color: #ffffff;
      line-height: 25px;
      margin: 6px;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.5);
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      padding: 19px 22px;
      box-sizing: border-box;
    }
  }
  .product_img {
    width: 100%;
    height: 130px;
    vertical-align: middle;
    border-radius: 6px;
    .img_img {
      width: 100%;
      max-height: 130px;
      display: block;
      margin: auto;
      border-radius: 6px 6px 0 0;
    }
  }
  .product_name {
    // height: 34px;
    margin-bottom: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #000;
    line-height: 14px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    .tag_img {
      height: 13.08px;
      margin-right: 4px;
    }
  }
  .product_price {
    padding: 7px 0;
    font-size: 16px;
    font-weight: 600;
    color: #000;
    text-align: left;
  }
  .mar_con {
    margin: 8px 5px 8px 8px;
  }
  .share_img {
    width: 20px;
  }
}
</style>
